import * as yup from 'yup';

export const containerSchema = yup.object({
  containerName: yup
    .string()
    .required('Supplier Invoice Reference is required'),

  containerRef: yup.string()
    .required('Container Reference is required')
    .matches(/^[A-Z]{4}[0-9]{6,7}(-[A-Z0-9]{1,7})?$/i, 
      'Container ID must follow format: 4 letters + 6-7 digits + optional hyphen and 1-7 alphanumeric characters'),
  departureDate: yup.string().required('Departure Date is required'),
  requestedDate: yup.string().required('Requested Date is required'),
  warehouseDatePlanned: yup
    .string()
    .required('Warehouse Date Planned is required'),
  mblNumber: yup.string()
    .optional()
    .matches(/^[a-z0-9]{5,20}$/i, 
      'MBL must be 5-20 alphanumeric characters'),
  arrivalDate: yup.string().required('Arrival Date is required'),
  bookingDate: yup.string().required('Booking Date is required'),
  warehouseDateActual: yup
    .string()
    .required('Warehouse Date Actual is required'),
  portDate: yup.string().required('Port Date is required'),
  freightCost: yup
    .number()
    .required('Freight Cost is required')
    .positive('Freight Cost must be a positive number'),
  localCost: yup
    .number()
    .required('Local Cost is required')
    .positive('Local Cost must be a positive number'),
});
